export default __webpack_public_path__ + "static/media/weatherWebsite.e0e15eb2.png";